module.exports = __webpack_public_path__ + "static/media/Flashbang-Rafiki-cards_spades-9.9c4bd066.svg";